<template>
  <div class="tech-page">
    <!-- Banner区域 -->
    <div class="banner">
      <div class="banner-content">
        <h1 class="title">数码科技</h1>
        <p class="subtitle">探索科技前沿，品味数码生活</p>
        <div class="search-container">
          <div class="search-box">
            <el-input
              v-model="searchText"
              placeholder="搜索科技资讯"
              class="search-input"
              :prefix-icon="Search"
            >
              <template #append>
                <el-button type="primary">搜索</el-button>
              </template>
            </el-input>
          </div>
        </div>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="container">
      <!-- 热门标签 -->
      <div class="hot-tags">
        <el-tag 
          v-for="tag in tags" 
          :key="tag.name"
          :type="tag.type"
          effect="plain"
          class="tag-item"
          @click="filterByTag(tag)"
        >
          {{ tag.name }}
        </el-tag>
      </div>

      <!-- 资讯列表 -->
      <div class="news-list">
        <!-- 置顶文章 -->
        <div class="featured-news" v-if="featuredNews">
          <el-card class="featured-card" @click="showNewsDetail(featuredNews)">
            <div class="featured-content">
              <div class="featured-image">
                <el-image :src="featuredNews.cover" fit="cover" />
                <div class="featured-badge">置顶</div>
              </div>
              <div class="featured-info">
                <h2>{{ featuredNews.title }}</h2>
                <p class="featured-desc">{{ featuredNews.description }}</p>
                <div class="featured-meta">
                  <span class="time">{{ featuredNews.time }}</span>
                  <span class="views">{{ featuredNews.views }} 阅读</span>
                </div>
              </div>
            </div>
          </el-card>
        </div>

        <!-- 普通文章列表 -->
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8" v-for="news in newsList" :key="news.id">
            <el-card class="news-card" @click="showNewsDetail(news)">
              <div class="news-image">
                <el-image :src="news.cover" fit="cover" />
                <div class="news-tag" :style="{ background: news.tagColor }">
                  {{ news.tag }}
                </div>
              </div>
              <div class="news-info">
                <h3 class="news-title">{{ news.title }}</h3>
                <p class="news-desc">{{ news.description }}</p>
                <div class="news-meta">
                  <span class="time">
                    <el-icon><Clock /></el-icon>
                    {{ news.time }}
                  </span>
                  <span class="views">
                    <el-icon><View /></el-icon>
                    {{ news.views }}
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>

        <!-- 加载更多 -->
        <div class="load-more">
          <el-button :loading="loading" @click="loadMore">加载更多</el-button>
        </div>
      </div>
    </div>

    <!-- 资讯详情对话框 -->
    <el-dialog
      v-model="dialogVisible"
      :title="currentNews?.title"
      width="70%"
      destroy-on-close
    >
      <div class="news-detail" v-if="currentNews">
        <div class="news-header">
          <div class="meta-info">
            <span class="time">发布时间：{{ currentNews.time }}</span>
            <span class="views">阅读量：{{ currentNews.views }}</span>
          </div>
          <el-tag size="small">{{ currentNews.tag }}</el-tag>
        </div>
        <div class="news-content" v-html="currentNews.content"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ref } from 'vue'
import { Search, Clock, View } from '@element-plus/icons-vue'

export default {
  name: 'Technology',
  components: {
    Clock,
    View
  },
  setup() {
    const searchText = ref('')
    const loading = ref(false)
    const dialogVisible = ref(false)
    const currentNews = ref(null)

    // 热门标签
    const tags = ref([
      { name: '全部', type: '' },
      { name: '手机', type: 'success' },
      { name: '电脑', type: 'warning' },
      { name: 'AI', type: 'danger' },
      { name: '智能家居', type: 'info' },
      { name: '数码', type: '' }
    ])

    // 置顶文章
    const featuredNews = ref({
      id: 1,
      title: '2024年最值得期待的科技产品',
      description: '从折叠屏手机到 AR 眼镜，盘点今年最受关注的科技新品...',
      cover: 'https://via.placeholder.com/800x400',
      time: '2024-03-18',
      views: '10.2k',
      tag: '热门',
      tagColor: '#ff4d4f'
    })

    // 文章列表
    const newsList = ref([
      {
        id: 2,
        title: 'AI 助手革新办公模式',
        description: '人工智能如何改变我们的工作方式...',
        cover: 'https://via.placeholder.com/400x300',
        time: '2024-03-17',
        views: '5.6k',
        tag: 'AI',
        tagColor: '#ff4d4f'
      },
      // ... 更多文章
    ])

    const showNewsDetail = (news) => {
      currentNews.value = news
      dialogVisible.value = true
    }

    const filterByTag = (tag) => {
      // 实现标签筛选逻辑
      console.log('Filter by tag:', tag.name)
    }

    const loadMore = () => {
      loading.value = true
      // 模拟加载更多数据
      setTimeout(() => {
        loading.value = false
      }, 1000)
    }

    return {
      searchText,
      tags,
      featuredNews,
      newsList,
      loading,
      dialogVisible,
      currentNews,
      showNewsDetail,
      filterByTag,
      loadMore,
      Search
    }
  }
}
</script>

<style scoped>
.banner {
  height: 300px;
  background-image: linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url('https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?ixlib=rb-4.0.3');
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -60px;
}

.banner-content {
  text-align: center;
  color: white;
  padding-top: 60px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.hot-tags {
  margin-bottom: 30px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.tag-item {
  cursor: pointer;
  padding: 8px 16px;
}

.featured-news {
  margin-bottom: 40px;
}

.featured-card {
  cursor: pointer;
  transition: transform 0.3s;
}

.featured-card:hover {
  transform: translateY(-5px);
}

.featured-content {
  display: flex;
  gap: 20px;
}

.featured-image {
  position: relative;
  width: 50%;
}

.featured-image .el-image {
  width: 100%;
  height: 300px;
  border-radius: 8px;
}

.featured-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background: #ff4d4f;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
}

.featured-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.featured-info h2 {
  font-size: 24px;
  margin-bottom: 16px;
  color: #333;
}

.featured-desc {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.featured-meta {
  color: #999;
  display: flex;
  gap: 20px;
}

.news-card {
  margin-bottom: 20px;
  cursor: pointer;
  transition: transform 0.3s;
}

.news-card:hover {
  transform: translateY(-5px);
}

.news-image {
  position: relative;
}

.news-image .el-image {
  width: 100%;
  height: 200px;
}

.news-tag {
  position: absolute;
  top: 10px;
  right: 10px;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.news-info {
  padding: 15px;
}

.news-title {
  font-size: 18px;
  margin-bottom: 10px;
  color: #333;
}

.news-desc {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 15px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-meta {
  display: flex;
  justify-content: space-between;
  color: #999;
  font-size: 14px;
}

.load-more {
  text-align: center;
  margin-top: 40px;
}

.news-detail {
  padding: 20px;
}

.news-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.meta-info {
  display: flex;
  gap: 20px;
  color: #999;
}

.news-content {
  line-height: 1.8;
  color: #333;
}

@media (max-width: 768px) {
  .banner {
    height: 300px;
  }

  .featured-content {
    flex-direction: column;
  }

  .featured-image {
    width: 100%;
  }

  .featured-image .el-image {
    height: 200px;
  }
}
</style> 